(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

  const recommendations = document.querySelector('[data-recommendations-url]');

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(recommendations);

    fetch(recommendations.dataset.recommendationsUrl)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const loadedRecommendations = html.querySelector('[data-recommendations-url]');

        if (loadedRecommendations.innerHTML.trim().length) {
          recommendations.innerHTML = loadedRecommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }

  if(recommendations){
    new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'}).observe(recommendations);
  }


  } catch(e) { console.error(e); }
})();
})();
